import { Http } from '../../../utils/Http';
import { TaxClaimImportRow } from '../TaxClaimTypes';

type GetImportXREFResponse = {
    rows: TaxClaimImportRow[];
}

type BeginFileImportResponse = {
    taxClaimID: number;
    jobKey: string;
}

type BeginCaseCreationResponse = {
    jobKey: string;
}

type UndoTaxClaimResponse = {
}

type SaveTaxClaimDetailsResponse = {

}

export async function beginCaseCreationApi(taxClaimId: number) {
    try {
        const options = {
            url: 'TaxClaim/BeginCaseCreation', 
            data: { taxClaimId }
        }
        const res = await Http.post<BeginCaseCreationResponse>(options);
        return res;
    } catch (err) {
        return { success: false, message: 'An internal server error has occurred.', jobKey: '' }
    }
}

export async function getImportRowsApi(taxClaimId: number) {
    try {
        const options = {
            url: 'TaxClaim/GetImportRows', 
            data: { taxClaimId }
        }
        const res = await Http.post<GetImportXREFResponse>(options);
        return res;
    } catch (err) {
        return { success: false, message: 'An internal server error has occurred.', rows: [] }
    }
}

type TaxClaimDetails = {
    taxClaimId: number;
    tempFileName: string;
    description: string;
    notes?: string;
}

export async function beginFileImportApi(details: TaxClaimDetails) {
    try {
        const options = {
            url: 'TaxClaim/BeginFileImport',
            data: details
        }
        const res = await Http.post<BeginFileImportResponse>(options);
        return res;
    } catch (err) {
        return { success: false, message: 'An internal server error has occurred', jobKey: '', taxClaimID: 0 }
    }   
}

export async function removeJobFromClaimApi(taxClaimId: number, jobKey: string) {
    const options = {
        url: 'TaxClaim/RemoveJobFromClaim',
        data: { taxClaimId, jobKey }
    }
    const res = await Http.post(options);
    return res;
}

export async function undoTaxClaimApi(taxClaimId: number) {
    const options = {
        url: 'TaxClaim/UndoTaxClaim', 
        data: { taxClaimId, confirm: true }
    }
    const res = await Http.post<UndoTaxClaimResponse>(options);
    return res;
}

export async function saveTaxClaimDetailsApi(taxClaimId: number, description: string, notes: string, fileName: string = '') {
    const options = {
        url: 'TaxClaim/Update', 
        data: { taxClaimId, description, notes, fileName }
    }
    const res = await Http.post<SaveTaxClaimDetailsResponse>(options);
    return res;
}